@if (isLoading) {
  <div class="flex flex-1 items-center justify-center py-20">
    <l-spinner />
  </div>
} @else if (loadErrorMessage) {
  <section class="flex flex-1 flex-col items-center justify-center gap-4 py-20 text-center">
    <p class="text-lDanger">{{ loadErrorMessage }}</p>
    <button
      type="button"
      lButton
      [bType]="buttonTypeEnum.PRIMARY"
      [bRadius]="buttonRadiusEnum.CIRCLE"
      [bSize]="buttonSizeEnum.MEDIUM"
      (click)="onCancel()"
    >
      Voltar para cursos
    </button>
  </section>
} @else {
<main class="flex w-full flex-col items-center gap-6 xl:flex-row xl:items-stretch">
  <section
    class="flex flex-col rounded-3xl bg-lGray900 p-6 md:p-8"
    [class.w-full]="activeStepId !== courseCreateStepEnum.MODULES && activeStepId !== courseCreateStepEnum.CONTENT"
    [class.max-w-2xl]="activeStepId === courseCreateStepEnum.MODULES || activeStepId === courseCreateStepEnum.CONTENT"
    [style.height]="activeStepId === courseCreateStepEnum.CONTENT || activeStepId === courseCreateStepEnum.MODULES ? '44rem' : null"
    [style.overflow]="activeStepId === courseCreateStepEnum.CONTENT || activeStepId === courseCreateStepEnum.MODULES ? 'hidden' : null"
  >
    <header class="mb-6 flex flex-col gap-2">
      <h1 class="text-2xl font-semibold text-lWhite md:text-4xl">
        {{ isUpdate ? 'Editar curso' : 'Criar novo curso' }}
      </h1>

      <p class="text-sm text-lSecondary">Para ativar o curso, é necessário adicionar ao menos um módulo.</p>
    </header>

    <p-tabs
      class="course-create-tabs mb-10 block"
      [value]="activeStepId"
      (valueChange)="onTabStepChange($event)"
    >
      <p-tablist aria-label="Etapas">
        @for (step of tabs; track step.id) {
          <p-tab [value]="step.id" [disabled]="step.disabled ?? false">
            {{ step.label }}
          </p-tab>
        }
      </p-tablist>
    </p-tabs>

    <l-course-about-step
      [class.hidden]="activeStepId !== courseCreateStepEnum.ABOUT"
      [attr.aria-hidden]="activeStepId !== courseCreateStepEnum.ABOUT"
      [aboutForm]="aboutForm"
      [categories]="categories"
      (coverPreviewStateChange)="onCoverPreviewState($event)"
      (coverPreviewSrcChange)="onCoverPreviewSrcChange($event)"
      (coverFileChange)="onCoverFileChange($event)"
    />

    @if (isFormReady) {
      <l-course-modules-step
        class="flex min-h-0 flex-1 flex-col overflow-y-auto"
        [class.hidden]="activeStepId !== courseCreateStepEnum.MODULES"
        [attr.aria-hidden]="activeStepId !== courseCreateStepEnum.MODULES"
        [modulesForm]="modulesForm"
        [isUpdate]="isUpdate"
        (addModule)="onAddModule()"
        (modulesChange)="onModulesFormChange()"
      />
    }

    <div
      class="flex min-h-0 flex-1 flex-col gap-6 xl:flex-row xl:items-stretch"
      [class.hidden]="activeStepId !== courseCreateStepEnum.CONTENT"
      [attr.aria-hidden]="activeStepId !== courseCreateStepEnum.CONTENT"
    >
      @if (isFormReady) {
        <l-course-content-step
          class="block h-full w-full overflow-y-auto"
          [modulesForm]="modulesForm"
          [selectedCard]="selectedCard"
          (addClass)="onAddClass($event)"
          (addEvaluation)="onEvaluationAdded($event)"
          (selectedContentCardChange)="onSelectedContentCardChange($event)"
          (modulesChange)="onModulesFormChange()"
        />
      }
    </div>

    <l-course-summary-step
      [class.hidden]="activeStepId !== courseCreateStepEnum.SUMMARY"
      [attr.aria-hidden]="activeStepId !== courseCreateStepEnum.SUMMARY"
      [aboutForm]="aboutForm"
      [categories]="categories"
      [moduleCount]="modulesForm.length"
      [coverImageSrc]="coverImageSrc"
    />
  </section>

  <section
    [class.hidden]="activeStepId !== courseCreateStepEnum.CONTENT || !selectedCard"
    data-course-content-panel
    class="flex h-[44rem] w-full min-w-0 flex-col overflow-y-auto xl:flex-1"
    [ngClass]="{
      'rounded-3xl p-6 bg-lGray900 md:p-8': selectedCard?.type === 'content',
      'bg-transparent': selectedCard?.type === 'evaluation'
    }"
  >
    @if (selectedCard?.type === 'content' && selectedClassForm) {
      <l-course-content-form
        class="block h-full w-full"
        [form]="selectedClassForm"
        [uploadState]="selectedClassContentUploadState"
        (uploadStateChange)="onSelectedClassContentUploadStateChange($event)"
      />
    } @else if (selectedCard?.type === 'evaluation' && selectedEvaluationForm) {
      <l-course-evaluation-form
        class="block h-full w-full"
        [form]="selectedEvaluationForm"
      />
    }
  </section>
</main>

<footer class="mt-14 mb-4 flex w-full flex-wrap items-center justify-between gap-4 pt-4">
  @if (activeStepId === courseCreateStepEnum.ABOUT) {
    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onCancel()"
      >
        Cancelar
      </button>

      @if (isUpdate && courseStatus === courseStatusEnum.DRAFT) {
        <button
          type="button"
          lButton
          [bType]="isCreateDisabled || isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
          [bRadius]="buttonRadiusEnum.CIRCLE"
          [bSize]="buttonSizeEnum.MEDIUM"
          class="gap-2"
          [disabled]="isCreateDisabled || isSaving"
          (click)="onSaveChanges()"
        >
          @if (isSaving) {
            <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
          }
          Salvar alterações
        </button>
      }
    </div>

    <div class="flex flex-wrap items-center gap-4">
      @if (isUpdate && courseStatus === courseStatusEnum.DRAFT) {
        <button
          type="button"
          lButton
          [bType]="isCreateDisabled || isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
          [bRadius]="buttonRadiusEnum.CIRCLE"
          [bSize]="buttonSizeEnum.MEDIUM"
          class="gap-2"
          [disabled]="isCreateDisabled || isSaving"
          (click)="onPublishCourse()"
        >
          @if (isSaving) {
            <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
          }
          Publicar
        </button>
      } @else {
        <button
          type="button"
          lButton
          [bType]="isCreateDisabled ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
          [bRadius]="buttonRadiusEnum.CIRCLE"
          [bSize]="buttonSizeEnum.MEDIUM"
          class="gap-2"
          [disabled]="isCreateDisabled"
          (click)="onCreateCourse()"
        >
          @if (isSaving) {
            <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
          }
          {{ isUpdate ? 'Salvar alterações' : 'Criar curso' }}
        </button>
      }
    </div>
  } @else if (activeStepId === courseCreateStepEnum.MODULES) {
    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onCancel()"
      >
        Cancelar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="gap-2"
        [disabled]="isSaving"
        (click)="onSaveDraftOrChanges()"
      >
        @if (isSaving) {
          <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
        }
        {{ isUpdate && courseStatus === courseStatusEnum.DRAFT ? 'Salvar alterações' : 'Salvar rascunho' }}
      </button>
    </div>

    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onBackToAbout()"
      >
        Voltar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving || modulesForm.length === 0 ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving || modulesForm.length === 0"
        (click)="onAdvanceToContent()"
      >
        Avançar
      </button>
    </div>
  } @else if (activeStepId === courseCreateStepEnum.CONTENT) {
    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onCancel()"
      >
        Cancelar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="gap-2"
        [disabled]="isSaving"
        (click)="onSaveDraftOrChanges()"
      >
        @if (isSaving) {
          <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
        }
        {{ isUpdate && courseStatus === courseStatusEnum.DRAFT ? 'Salvar alterações' : 'Salvar rascunho' }}
      </button>
    </div>

    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onBackToModules()"
      >
        Voltar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving || !canAccessSummaryStep ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving || !canAccessSummaryStep"
        (click)="onAdvanceToSummary()"
      >
        Avançar
      </button>
    </div>
  } @else if (activeStepId === courseCreateStepEnum.SUMMARY) {
    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onCancel()"
      >
        Cancelar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="gap-2"
        [disabled]="isSaving"
        (click)="onSaveDraftOrChanges()"
      >
        @if (isSaving) {
          <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
        }
        {{ isUpdate && courseStatus === courseStatusEnum.DRAFT ? 'Salvar alterações' : 'Salvar rascunho' }}
      </button>
    </div>

    <div class="flex flex-wrap items-center gap-4">
      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.OUTLINE"
        [outline]="!isSaving"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        [disabled]="isSaving"
        (click)="onBackToContent()"
      >
        Voltar
      </button>

      <button
        type="button"
        lButton
        [bType]="isSaving ? buttonTypeEnum.DISABLED : buttonTypeEnum.PRIMARY"
        [bRadius]="buttonRadiusEnum.CIRCLE"
        [bSize]="buttonSizeEnum.MEDIUM"
        class="gap-2"
        [disabled]="isSaving"
        (click)="isUpdate && courseStatus !== courseStatusEnum.DRAFT ? onSaveChanges() : onPublishCourse()"
      >
        @if (isSaving) {
          <l-spinner [color]="spinnerColorEnum.WHITE" [size]="spinnerSizeEnum.SMALL" />
        }
        {{ isUpdate && courseStatus !== courseStatusEnum.DRAFT ? 'Salvar alterações' : 'Publicar' }}
      </button>
    </div>
  }
</footer>
}
